import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types"; // import PropTypes
import MonthOption from "Components/Form/MonthSelect";
import YearOption from "Components/Form/YearSelect";
import { Link, useNavigate } from "react-router-dom";
import { format } from "date-fns";
// import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { Edit, PlusCircle } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { useForm, FormProvider } from "react-hook-form";
import {
  useGeneratePayrollQuery,
  useReCalculatePayrollGenerationMutation,
} from "AppQuries/payroll/generate-payroll";
import Error404 from "MainPages/ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { Alert, Spin, Input, Table, Select, Checkbox, DatePicker } from "antd";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { setPayrollValues } from "core/Operations/payroll/setPayrollValues";
import { RefreshCcw, Save } from "react-feather";
import Swal from "sweetalert2";
import styles from "./GeneratePayroll.module.css";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import Select2 from "react-select2-wrapper";
import { useStagingPayrollMutation } from "AppQuries/payroll/staging";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  payrollStagingValidation,
  salaryUpdateReGenerateValidation,
} from "core/Operations/ValidationSchema/payrollValidation";
import {
  useFormattedDepartmentOption,
  useFormattedEmployees,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import GeneratePayrollFilters from "./filter/generatePayrollFiters";
import dayjs from "dayjs";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const salaryTypeOptions = [
  {
    id: "01",
    label: "Monthly",
    value: "Monthly",
  },
  // {
  //   id: "02",
  //   label: "Daily",
  //   value: "Daily",
  // },
  {
    id: "03",
    label: "Hourly",
    value: "Hourly",
  },
];

const isExcludeOption = [
  {
    id: true,
    label: "Yes",
    value: "True",
  },
  {
    id: false,
    label: "No",
    value: "False",
  },
];
const GeneratePayroll = () => {
  const userData = useSelector(loggedInUser);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tempHourlySalary, setTempHourlySalary] = useState({});
  const [tempMonthSalary, setTempMonthSalary] = useState({});
  const [tempDaySalary, setTempDaySalary] = useState({});
  const [payrollData, setPayrollData] = useState([]);

  const { data: employeesData } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const departmentOptions = useFormattedDepartmentOption(userData?.companyCode);

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });
  const [employeeCode, setEmployeeCode] = useState(0);

  const navigate = useNavigate();
  const [payslipListData, setPayslipListData] = useState([]);

  const [queryParams, setQueryParams] = useState({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
    excludeTime: "",
    month: 0,
    year: 0,
    salaryType: "Monthly",
    departmentCode: 0,
    userCode: userData?.userName,
  });
  const [selectedSalaryType, setSelectedSalaryType] = useState("Monthly");

  const methods = useForm({
    // resolver : yupResolver(payrollStagingValidation)
  });
  const {
    register,
    watch,
    getValues,
    setValue,
    handleSubmit,
    formState: { errors },
  } = methods;

  const {
    data,
    isFetching: generatingPayroll,
    isError: isGeneratePayrollError,
    error: generatePayrollError,
    refetch: reGeneratePayroll,
  } = useGeneratePayrollQuery(
    {
      ...queryParams,
    },
    {
      enabled: false,
    },
  );

  const {
    mutate: stagingPayroll,
    isError,
    error,
    isPending,
    isFetching,
  } = useStagingPayrollMutation(); //useSavePayrollMutation();

  const {
    mutate: reCalculateSalaryMutate,
    isPending: isReCalculatePending,
    isError: isReCalculateError,
    error: reCalculateError,
  } = useReCalculatePayrollGenerationMutation();

  const onSubmit = (data) => {
    if (selectedRowKeys.length === 0) {
      Swal.fire({
        type: "warning",
        title: "Warning!",
        text: "Please select at least one employee",
        confirmButtonClass: "btn btn-primary",
      });
      return;
    } else {
      Swal.fire({
        title: "Confirm to submit?",
        text: "Are you sure you want submit payroll",
        type: "warning",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: 1,
        buttons: ["Cancel", "Submit"],
      }).then(function (t) {
        if (t.isConfirmed) {
          // console.log("payrollData",payrollData)
          let jsonData = [];

          const selectedPayrollData = payrollData.filter((payroll) =>
            selectedRowKeys.includes(payroll.employeeCode),
          );

          selectedPayrollData?.forEach((payroll) => {
            jsonData.push({
              companyCode: payroll.companyCode,
              locationCode: payroll.locationCode || userData.locationCode,
              refNo: payroll.refNo,
              employeeCode: payroll.employeeCode,
              icno: payroll.icNo,
              processDateStr: format(new Date(), "yyyy-MM-dd"),
              procesMonth: Number(queryParams.month),
              processYear: Number(queryParams.year),
              paymentCode: Number(payroll.paymentCode),
              departmentCode: Number(payroll.departmentCode),
              monthlySalary: Number(payroll.monthlySalary),
              basicSalary: Number(payroll.basicSalary),
              grossSalary: Number(payroll.grossSalary),
              addition: Number(payroll.addition),
              deduction: Number(payroll.deduction),

              // totalCpf: Number(payroll.totalCPF),
              // employeeCpf: Number(payroll.employeeCPF),
              // employerCpf: Number(payroll.employerCPF),
              totalCpf: Number(payroll.totalPercentage) ?? 0,
              employeeCpf: Number(payroll.employeePercentage) ?? 0,
              employerCpf: Number(payroll.employerPercentage) ?? 0,
              leaveTakenInDays: Number(payroll.leaveTakenInDays),
              leaveSalaryAmount: Number(payroll.leaveSalaryAmount),
              netPay: Number(payroll.netPay),
              contributionCode: payroll.contributionCode,
              agencyAmount: Number(payroll.agencyAmount),
              sdlAmount: Number(payroll.sdlAmount),
              noOfDaysInMonth: Number(payroll.noOfDaysInMonth),
              noOfWorkingDays: Number(payroll.noOfDaysInMonth),
              hourlySalary: Number(payroll.hourlySalary),
              additionalHours: Number(payroll.additionalHours),
              deductionHours: Number(payroll.deductionHours),
              otHourlySalary: Number(payroll.otHourlySalary),
              noOfOTWorkingDays: Number(payroll.noOfOTWorkingDays),
              // otDaySalary: Number(payroll.otDaySalary),
              otDaySalary: payroll.noOfOTWorkingDaysSalary,
              payrollValue: Number(payroll.payrollValue),
              salaryPayable: Number(payroll.salaryPayable),
              createUser: userData.createUser,
              extraorlessHourAmount: Number(payroll.extraorlessHourAmt),
              daySalary: Number(payroll.daySalary),
              payrollDetail: payroll.payrollDetails, //.length > 0 ? payroll.payrollDetail.map(d => ( {...d})) : []
              waitingTime: Number(payroll.waitingTime) ?? 0,
              waitingTimeSalary: Number(payroll.waitingTimeSalary) ?? 0,
              advancePayment: Number(payroll.advancePayment) ?? 0,
              normalWorkingHoursInMonth:
                Number(payroll.normalWorkingHoursInMonth) ?? 0,
              normalWorkingHoursSalary:
                Number(payroll.normalWorkingHoursSalary) ?? 0,
              oT1Hours: Number(payroll.oT1Hours) ?? 0,
              oT1HourlySalary: Number(payroll.oT1HourlySalary) ?? 0,
              oT2Hours: Number(payroll.oT2Hours) ?? 0,
              oT2HourlySalary: Number(payroll.oT2HourlySalary) ?? 0,
              extraHours: Number(payroll.extraHours) ?? 0,
              extraHoursSalary: Number(payroll.extraHoursSalary) ?? 0,
              publicHolidayOTHours: Number(payroll.publicHolidayOTHours) ?? 0,
              publicHolidayOTHoursSalary:
                Number(payroll.publicHolidayOTHoursSalary) ?? 0,
              paidLeaveDays: Number(payroll.paidLeaveDays) ?? 0,
              paidLeaveSalary: Number(payroll.paidLeaveSalary) ?? 0,
              publicHolidayHours: Number(payroll.publicHolidayHours) ?? 0,
              publicHolidayHoursSalary:
                Number(payroll.publicHolidayHoursSalary) ?? 0,
              leaveAmount: Number(payroll.leaveAmount) ?? 0,
              employeePercentage: Number(payroll.employeePercentage) ?? 0,
              employerPercentage: Number(payroll.employerPercentage) ?? 0,
              levyAmount: Number(payroll.levyAmount) ?? 0,
              payMonth: payroll.payMonth,
            });
          });

          stagingPayroll(jsonData, {
            onSuccess: (response) => {
              if (response[0].response === true) {
                Swal.fire({
                  type: "success",
                  title: "Payroll Generated!",
                  text: "Payroll Generated Successfully..",
                  confirmButtonClass: "btn btn-success",
                }).then(function (t) {
                  navigate(`${all_routes.payroll}${all_routes.payroll_stage}`);
                });
              } else {
                Swal.fire({
                  title: "Warning!",
                  text: response[0].errorMessage,
                  type: "warning",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Ok",
                  confirmButtonClass: "btn btn-primary",
                  okButtonClass: "",
                  buttonsStyling: 1,
                });
              }
            },
          });
        }
      });
    }
  };

  useEffect(() => {
    setPayslipListData(payrollData);
    setPayrollValues(methods, payrollData);
  }, [payrollData]);

  useEffect(() => {
    const formatted =
      (Array.isArray(data) &&
        data?.map((d, index) => ({
          ...d,
          id: index + 1,
          key: index,
        }))) ||
      [];
    setPayrollData(formatted);
  }, [data]);

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const updateRowInState = (index, updatedRow) => {
    
    updatedRow.key = index;
    setPayrollData((prev) =>
      prev.map((row) =>
        row.key === updatedRow.key ? { ...row, ...updatedRow } : row,
      ),
    );
  };

  const updateRowInForm = (index, updatedRow) => {
    Object.keys(updatedRow).forEach((key) => {
      setValue(`payrollData[${index}].${key}`, updatedRow[key]);
    });
  };

  const reCalculateSalary = async (record, salary) => {
    // const salary =
    //   record?.salaryType === "Monthly"
    //     ? record?.basicSalary
    //     : record?.salaryType === "Hourly"
    //       ? record?.hourlySalary
    //       : record?.salaryType === "Daily"
    //         ? record?.daySalary
    //         : 0;
    let payload = {
      companyCode: record?.companyCode,
      locationCode: record?.locationCode,
      month: record?.procesMonth.toString(),
      year: record?.processYear?.toString(),
      userCode: userData?.userID,
      salaryType: record?.salaryType,
      employeeCode: record?.employeeCode,
      basicSalary: Number(salary) || 0,
    };

    try {
      await salaryUpdateReGenerateValidation.validate(payload);
    } catch (err) {
      Swal.fire({
        title: "Warning!",
        text: err.message,
        type: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
        confirmButtonClass: "btn btn-primary",
        okButtonClass: "",
        buttonsStyling: 1,
      });
      return;
    }

    reCalculateSalaryMutate(payload, {
      onSuccess: (response) => {
        console.log("response", response);

        if (response?.response === true) {
          if (Array.isArray(response?.data)) {
            updateRowInState(record?.key, response?.data?.[0] || {});

            updateRowInForm(record?.key, response?.data?.[0] || {});
          }

          Swal.fire({
            type: "success",
            title: "Salary Updated!",
            text: "Salary Updated Successfully..",
            confirmButtonClass: "btn btn-success",
          });
          // .then(function (t) {
          //   navigate(`${all_routes.payroll}${all_routes.payroll_stage}`);
          // });
        } else {
          Swal.fire({
            title: "Warning!",
            text: response?.errorMessage || "Something went wrong",
            type: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
            confirmButtonClass: "btn btn-primary",
            okButtonClass: "",
            buttonsStyling: 1,
          });
        }
      },
      onError: (error) => {
        Swal.fire({
          title: "Error!",
          text: error.message,
          type: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
          confirmButtonClass: "btn btn-primary",
          okButtonClass: "",
          buttonsStyling: 1,
        });
      },
    });

    setTempMonthSalary({});
    setTempHourlySalary({});
    setTempDaySalary({});
  };
  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      key: "uniqueID",
    },
    {
      title: "Emp Name",
      dataIndex: "fullName",
      key: "fullName",
      fixed: "left",
      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {text}
        </Link>
      ),
    },
    ...(selectedSalaryType === "Monthly"
      ? [
          {
            title: "Basic Pay ($)",
            dataIndex: "basicSalary",
            key: "basicSalary",
            render: (text, record, index) => (
              <div className="d-flex">
                <input
                  className="form-control payroll-input"
                  value={tempMonthSalary[index] ?? text ?? ""}
                  style={{ width: "100px" }}
                  onChange={(e) => {
                    setTempMonthSalary((prev) => ({
                      ...prev,
                      [index]: e.target.value,
                    }));
                    console.log(tempMonthSalary);
                  }}
                />

                <button
                  type="button"
                  className="btn btn-default ms-1"
                  onClick={() =>
                    reCalculateSalary(record, tempMonthSalary[index])
                  }
                  disabled={
                    tempMonthSalary[index] === undefined ||
                    tempMonthSalary[index] === "" ||
                    isNaN(Number(tempMonthSalary[index]))
                  }
                  style={{ border: "none" }}
                >
                  <span className="me-1 d-flex align-items-center">
                    <RefreshCcw className="feather-16" size={12} />
                  </span>
                </button>
                {/* <Input
                  {...register(`payrollData[${index}].basicSalary`)}
                  className="form-control payroll-input"
                  defaultValue={text || ""}
                  readOnly={false}
                  style={{ width: "100px" }}
                />
                <button
                  type="button"
                  className="btn btn-default ms-1"
                  onClick={() => reCalculateSalary(record)}
                >
                  <span className="me-1 d-flex align-items-center">
                    <RefreshCcw className="feather-16" size={12} />
                  </span>
                </button> */}
              </div>
            ),
          },
        ]
      : []),
    ...(selectedSalaryType === "Hourly"
      ? [
          {
            title: "Hourly Pay ($)",
            dataIndex: "hourlySalary",
            key: "hourlySalary",
            render: (text, record, index) => (
              <div className="d-flex">
                <input
                  className="form-control payroll-input"
                  value={tempHourlySalary[index] ?? text ?? ""}
                  // defaultValue={text || ""}
                  style={{ width: "100px" }}
                  onChange={(e) => {
                    setTempHourlySalary((prev) => ({
                      ...prev,
                      [index]: e.target.value,
                    }));
                  }}
                />

                <button
                  type="button"
                  className="btn btn-default ms-1"
                  onClick={() =>
                    reCalculateSalary(record, tempHourlySalary[index])
                  }
                  disabled={
                    tempHourlySalary[index] === undefined ||
                    tempHourlySalary[index] === "" ||
                    isNaN(Number(tempHourlySalary[index]))
                  }
                  style={{ border: "none" }}
                >
                  <span className="me-1 d-flex align-items-center">
                    <RefreshCcw className="feather-16" size={12} />
                  </span>
                </button>
                {/* <Input
                  {...register(`payrollData[${index}].basicSalary`)}
                  className="form-control payroll-input"
                  defaultValue={text || ""}
                  readOnly={false}
                  style={{ width: "100px" }}
                />
                <button
                  type="button"
                  className="btn btn-default ms-1"
                  onClick={() => reCalculateSalary(record)}
                >
                  <span className="me-1 d-flex align-items-center">
                    <RefreshCcw className="feather-16" size={12} />
                  </span>
                </button> */}
              </div>
            ),
          },
        ]
      : []),
    ...(queryParams.salaryType === "Daily"
      ? [
          {
            title: "Day Salary ($)",
            dataIndex: "daySalary",
            key: "daySalary",
            render: (text, record, index) => (
              <div className="d-flex">
                <input
                  className="form-control payroll-input"
                  // defaultValue={text || ""}
                  value={tempDaySalary[index] ?? text ?? ""}
                  style={{ width: "100px" }}
                  onChange={(e) => {
                    setTempDaySalary((prev) => ({
                      ...prev,
                      [index]: e.target.value,
                    }));
                  }}
                />

                <button
                  type="button"
                  className="btn btn-default ms-1"
                  onClick={() =>
                    reCalculateSalary(record, tempDaySalary[index])
                  }
                  disabled={
                    tempDaySalary[index] === undefined ||
                    tempDaySalary[index] === "" ||
                    isNaN(Number(tempDaySalary[index]))
                  }
                  style={{ border: "none" }}
                >
                  <span className="me-1 d-flex align-items-center">
                    <RefreshCcw className="feather-16" size={12} />
                  </span>
                </button>
                {/* <Input
                  {...register(`payrollData[${index}].basicSalary`)}
                  className="form-control payroll-input"
                  defaultValue={text || ""}
                  readOnly={false}
                  style={{ width: "100px" }}
                />
                <button
                  type="button"
                  className="btn btn-default ms-1"
                  onClick={() => reCalculateSalary(record)}
                >
                  <span className="me-1 d-flex align-items-center">
                    <RefreshCcw className="feather-16" size={12} />
                  </span>
                </button> */}
              </div>
            ),
          },
        ]
      : []),

    {
      // title: "No.of Days in Month",
      title: "No.of Working Days",
      dataIndex: "noOfDaysInMonth",
      key: "noOfDaysInMonth",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].noOfDaysInMonth`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "75px" }}
        />
      ),
    },
    {
      title: "No.of Worked Days / Hours",
      dataIndex: "payrollValue",
      key: "payrollValue",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].payrollValue`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "75px" }}
        />
      ),
    },
    {
      title: "OT Pay (Day) ($)",
      dataIndex: "noOfOTWorkingDaysSalary",
      key: "noOfOTWorkingDaysSalary",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].noOfOTWorkingDaysSalary`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "75px" }}
        />
      ),
    },
    {
      title: "OT Pay (Hour) ($)",
      dataIndex: "otHourlySalary",
      key: "otHourlySalary",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].otHourlySalary`)}
          // value={
          //   Number(watch(`payrollData[${index}].otHourlySalary`)) *
          //   Number(watch(`payrollData[${index}].additionalHours`))
          // }
          value={text}
          className="form-control payroll-input"
          readOnly
          style={{ width: "75px" }}
        />
      ),
    },
    // {
    //   title: "Leave Amount",
    //   dataIndex: "leaveAmount",
    //   key: "leaveAmount",
    //   render: (text, record, index) => (
    //     <Input
    //       {...register(`payrollData[${index}].leaveAmount`)}
    //       value={Number(text).toFixed(2)}
    //       className="form-control payroll-input"
    //       readOnly
    //       style={{ width: "100px" }}
    //     />
    //   ),
    // },
    {
      title: "Monthly Salary ($)",
      dataIndex: "monthlySalary",
      key: "monthlySalary",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].monthlySalary`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },

    {
      title: "Allowances ($)",
      dataIndex: "addition",
      key: "addition",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].addition`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },
    {
      title: "Other allowance ($)",
      dataIndex: "waitingTimeSalary",
      key: "waitingTimeSalary",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].waitingTimeSalary`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },

    {
      title: "Gross Salary ($)",
      dataIndex: "grossSalary",
      key: "grossSalary",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].grossSalary`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },
    {
      title: "Deduction Hours ($)",
      dataIndex: "extraorlessHourAmt",
      key: "extraorlessHourAmt",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].extraorlessHourAmt`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "75px" }}
        />
      ),
    },
    {
      title: "Leave Taken Days",
      dataIndex: "leaveTakenInDays",
      key: "leaveTakenInDays",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].leaveTakenInDays`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "75px" }}
        />
      ),
    },
    {
      title: "Leave Salary Amount ($)",
      dataIndex: "leaveAmount",
      key: "leaveAmount",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].leaveAmount`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "75px" }}
        />
      ),
    },

    {
      title: "Deductions ($)",
      dataIndex: "deduction",
      key: "deduction",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].deduction`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },
    {
      title: "Advance Payment ($)",
      dataIndex: "advancePayment",
      key: "advancePayment",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].advancePayment`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },

    {
      title: "Emp CPF ($)",
      dataIndex: "employeePercentage",
      key: "employeePercentage",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].employeePercentage`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },
    {
      title: "Employer CPF ($)",
      dataIndex: "employerPercentage",
      key: "employerPercentage",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].employerPercentage`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },
    {
      title: "Fund ($)",
      dataIndex: "agencyAmount",
      key: "agencyAmount",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].agencyAmount`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },
    {
      title: "SDL ($)",
      dataIndex: "sdlAmount",
      key: "sdlAmount",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].sdlAmount`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },
    {
      title: "Net Pay ($)",
      dataIndex: "netPay",
      key: "netPay",
      render: (text, record, index) => (
        <Input
          {...register(`payrollData[${index}].netPay`)}
          className="form-control payroll-input"
          value={text}
          readOnly
          style={{ width: "100px" }}
        />
      ),
    },
  ];

  const handleSelect = (record, selected) => {
    if (selected) {
      setSelectedRowKeys((keys) => [...keys, record.employeeCode]);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.employeeCode);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });
    }
  };

  const toggleSelectAll = () => {
    setSelectedRowKeys((keys) =>
      keys.length === payrollData.length
        ? []
        : payrollData.map((r) => r.employeeCode),
    );
  };

  const headerCheckbox = (
    <Checkbox
      checked={selectedRowKeys.length}
      indeterminate={
        selectedRowKeys.length > 0 &&
        selectedRowKeys.length < payrollData.length
      }
      style={{ zIndex: "unset" }}
      onChange={toggleSelectAll}
    />
  );

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    // fixed: true,
    onSelect: handleSelect,
    columnTitle: headerCheckbox,
    //onSelectAll: this.handleSelectAll
  };
  const searchColumns = columns.map((column) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    payrollData,
    searchColumns,
  );

  useEffect(() => {
    setSelectedSalaryType(queryParams.salaryType);
  }, [payrollData]);
  // const updateQueryParams = (key, value) => {
  //   setFilter((prev) => ({ ...prev, [key]: value }));
  // };

  if (isGeneratePayrollError) return <Error404 error={generatePayrollError} />;
  if (isError) return <Error404 error={error} />;
  if (generatingPayroll) return <LoadingSpinner />;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Generate Payroll</h4>
              <h6>Generate employees monthly Payroll</h6>
            </div>
          </div>
          {/* <div className="page-btn">
            <GeneratePayrollFilters
              type="select"
              name="departmentCode"
              label="Department"
              placeholder="Select Department"
              currentValue={departmentCode}
              options={departmentOptions}
              updateQueryParams={updateQueryParams}
            />
          </div> */}
          <div className="page-btn">
            <div className="row form-row">
              <div className="col-2">
                <div className="form-floating">
                  <Select
                    className={`form-control select`}
                    options={departmentOptions}
                    placeholder="Select Department"
                    onSelect={(e) =>
                      updateQueryParams("departmentCode", e || "")
                    }
                    onClear={() => updateQueryParams("departmentCode", 0)}
                    allowClear
                    style={{ width: "150px" }}
                    value={
                      queryParams.departmentCode === 0
                        ? ""
                        : queryParams.departmentCode
                    }
                  />
                  <label className="form-label">Department</label>
                </div>
              </div>
              &nbsp;
              <div className="col-2">
                <div className="form-floating">
                  <Select
                    className={`form-control select`}
                    options={isExcludeOption}
                    placeholder="Select Exclude Time"
                    onSelect={(e) => updateQueryParams("excludeTime", e)}
                    style={{ width: "150px" }}
                    value={queryParams.excludeTime}
                  />
                  <label className="form-label">Exclude Time</label>
                </div>
              </div>
              &nbsp;
              <div className="col-2">
                <div className="form-floating">
                  <Select
                    className={`form-control select`}
                    options={salaryTypeOptions}
                    placeholder="Select Salary Type"
                    onSelect={(e) => updateQueryParams("salaryType", e)}
                    style={{ width: "150px" }}
                    value={queryParams.salaryType}
                  />
                  <label className="form-label">Salary Type</label>
                </div>
              </div>
              &nbsp;
              <div className="col-2">
                <div className="form-floating">
                  <DatePicker
                    className={`form-control select`}
                    picker="month"
                    onChange={(date) => {
                      if (date) {
                        updateQueryParams("month", date.month() + 1); // 🔹 +1 to store as 1–12
                        updateQueryParams("year", date.year());
                      } else {
                        updateQueryParams("month", 0);
                        updateQueryParams("year", 0);
                      }
                    }}
                    value={
                      queryParams.year !== 0 && queryParams.month !== 0
                        ? dayjs(
                            `${queryParams.year}-${queryParams.month}`,
                            "YYYY-M",
                          )
                        : null
                    }
                    format={"MM-YYYY"}
                    style={{ width: "150px" }}
                  />
                  <label className="form-label">Month & Year</label>
                </div>
              </div>
              &nbsp; &nbsp; &nbsp;
              <div
                className="col-2"
                style={{
                  padding: "10px 20px",
                  marginTop: "2px",
                  marginLeft: "5px",
                }}
              >
                <Can
                  accessModule={accessCodes.payroll_management}
                  accessCode={accessCodes.payroll_generation}
                  accessType="haveAdd"
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Generate Payroll</Tooltip>
                    }
                  >
                    <button
                      className="btn btn-secondary"
                      type="button"
                      onClick={reGeneratePayroll}
                      disabled={
                        queryParams.month === 0 || queryParams.year === 0
                      }
                    >
                      Generate
                    </button>
                  </OverlayTrigger>
                </Can>
              </div>
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card border-0">
            <div className="card-body table-list-card">
              <div className="row">
                <TableTop
                  onSearch={setSearchValue}
                  toggleFilterVisibility={() => {}}
                  searchValue={searchValue}
                  showSearch={true}
                  showToggle={false}
                  isFilterVisible={true}
                />
                <div
                  className={`table-responsive ${styles["table-responsive-2"]}`}
                >
                  <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={filteredData}
                    rowKey={(record, index) => record.employeeCode || index}
                    pagination={false}
                    loading={isReCalculatePending || isFetching}
                    size="small"
                  />
                </div>
              </div>
            </div>
            {watch("payrollData") && watch("payrollData").length > 0 && (
              <div className="card-footer">
                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={generatingPayroll || isPending || isFetching}
                  >
                    {generatingPayroll || isPending || isFetching ? (
                      <>
                        <i className="fas fa-spinner fa-spin me-2" /> Loading...
                      </>
                    ) : (
                      <>
                        <Save className="me-2" />
                        Save Payroll
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

// GeneratePayroll.propTypes = {
//   // payrollData: PropTypes.arrayOf(
//   //   PropTypes.shape({
//   //     fullName: PropTypes.string.isRequired,
//   //     basicSalary: PropTypes.number,
//   //     payrollValue: PropTypes.number,
//   //     otDaySalary: PropTypes.number,
//   //     otHourlySalary: PropTypes.number,
//   //     additionalHours: PropTypes.number,
//   //     leaveAmount: PropTypes.number,
//   //     monthlySalary: PropTypes.number,
//   //     extraorlessHourAmt: PropTypes.number,
//   //     addition: PropTypes.number,
//   //     grossSalary: PropTypes.number,
//   //     deduction: PropTypes.number,
//   //     employeePercentage: PropTypes.number,
//   //     employerPercentage: PropTypes.number,
//   //     agencyAmount: PropTypes.number,
//   //     sdlAmount: PropTypes.number,
//   //     netPay: PropTypes.number,
//   //   })
//   // ),
//   payrollData: PropTypes.array.isRequired,
//   payrollMonth: PropTypes.number,
//   payrollYear: PropTypes.number,
//   userData: PropTypes.shape({
//     companyCode: PropTypes.string.isRequired,
//     userName: PropTypes.string.isRequired,
//   }),
//   monthSelectHandler: PropTypes.func,
//   yearSelectHandler: PropTypes.func,
// };

export default GeneratePayroll;
